var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('commission-statement-ordered',{attrs:{"closing":_vm.closing,"read_only":_vm.read_only}}),_vm._v(" "),_c('wire-instructions',{attrs:{"closing":_vm.closing,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }